module.exports = __webpack_public_path__ + "img/cardNumBg.211b9411.png";